module.exports = __webpack_public_path__ + "static/media/picker-empty.701716d4.svg";